
export class GenerateImagePath{

    static getPath(id, zeile='1', level=1){

        var src = "https://www.projekt14.de/austausch/quick_h/";
        src += id;
        if (zeile > 1) {
            src += level > 1 ? '' : '_1';
        }
        src += ".png?t=" + window.cTStamp; //new Date().getTime();
        return   src;
    }
}
